<template>
    <form @submit.prevent="store()" v-show="show">
        <div class="modal_content p-15 m-0">
            <div class="row">
                <div class="col-sm-6 col-md-8 m_bottom_15">
                    <label>{{ $t('supplier') }}</label>
                    <pml-select v-model="supplier" :options="suppliers" label="fancy_name"></pml-select>
                </div>
                <div class="col-sm-6 col-md-4 m-t-30">
                    <pml-switch v-model="record.show_details" :text="$t('show_details')" class="switch_text_left"></pml-switch>
                </div>
            </div>
            <div class="row">
                <div class="col-md-12 m-b-15" :class="{'has-error': errors['id']}">
                    <label>{{ $t('product') }}</label>
                    <div class="custom_select">
                        <vue-multiselect
                            v-model="product"
                            track-by="id"
                            label="product_name"
                            :placeholder="$t('select_an_option')"
                            :allow-empty="true"
                            :internal-search="true"
                            :options="products"
                            :searchable="true"
                            :loading="loadingProducts"
                            :customLabel="customLabel"
                            selectLabel=""
                            selectedLabel=""
                            deselectLabel=""
                            :disabled="!supplier"></vue-multiselect>
                    </div>
                    <span class="error" v-if="errors['id']">{{ errors['id'][0] }}</span>
                </div>
            </div>
            <div class="row" v-if="product">
                <div class="col-xs-12 col-sm-4 m-b-15" :class="{'has-error': errors['amount']}">
                    <label>{{ $t('amount') }}</label>
                    <input type="text" v-pml-focus class="form-control" v-model.lazy="record.amount" v-pml-mask="'number'">
                    <span class="error" v-if="errors['amount']">{{ errors['amount'][0] }}</span>
                </div>
                <div class="col-xs-12 col-sm-4 m-b-15" :class="{'has-error': errors['price']}">
                    <label>{{ $t('unit_price') }}</label>
                    <label class="input-group">
                        <pml-numeric v-model="record.price" :disabled="!product.allow_edit"></pml-numeric>
                        <span class="input-group-addon">{{ product.supplier.currency_id | pmlCurrencyById('symbol') }}</span>
                    </label>
                    <span class="error" v-if="errors['price']">{{ errors['price'][0] }}</span>
                </div>
                <div class="col-xs-12 col-sm-4 m-b-15" :class="{'has-error': errors['unit']}">
                    <label>{{ $t('unit') }}</label>
                    <span class="form-control disabled bg_gray_light">{{ $t(product.unit) }}</span>
                </div>
                <div class="col-sm-12 m-b-15" :class="{'has-error': errors['description']}">
                    <label>{{ $t('product_description_in_quotation') }}</label>
                    <textarea class="form-control" rows="4" v-pml-autosize v-model="record.description"></textarea>
                    <span class="error" v-if="errors['description']">{{ errors['description'][0] }}</span>
                </div>
            </div>
            <div class="clearfix">
                <span class="btn btn-white" @click.prevent="cancel()">{{ $t('cancel') }}</span>
                <button type="submit" class="btn btn-default pull-right" v-pml-block="isSaving">{{ $t('save') }}</button>
            </div>
        </div>
    </form>
</template>

<script>
    import Notify from 'utils/helpers/notify'
    import { trans } from 'utils/helpers/translation'
    import { create } from 'services/quotation-products'
    import { getProducts } from 'services/suppliers'
    import { findCurrency } from 'utils/helpers/find-store'
    import { mapGetters } from 'vuex'
    import { find, isEmpty, isNull, cloneDeep, filter } from 'lodash'

    export default {
        name: 'QuotationAddProduct',
        props: [ 'show' ],
        data () {
            return {
                products: [],
                product: null,
                supplier: null,
                record: {
                    show_details: false
                },
                errors: [],
                isSaving: false,
                loadingProducts: false
            }
        },
        computed: {
            ...mapGetters({
                'suppliers': 'getActiveSuppliers',
                'deal': 'getDealInfo',
                'quotations': 'getDealQuotations',
                'tenant': 'getTenant'
            }),
            quotation () {
                return find(this.quotations, {id: parseInt(this.$route.params.quotation)}) || {}
            }
        },
        watch: {
            'supplier' (val, old) {
                if (val !== old)
                    this.product = null
                isNull(val) ? this.products = [] : this.loadProducts(val)
                this.record.show_details = false
            },
            'product' (val) {
                isNull(val) ? this.clear() : this.record = {...cloneDeep(val), show_details: this.record.show_details}
            }
        },
        methods: {
            getCurrency: (id) => findCurrency(id),
            customLabel ({ product, annotations }) {
                let notes = isEmpty(annotations) ? '' : ` - ${annotations}`
                return `${product.name} ${notes}`
            },
            store () {
                this.isSaving = true

                create(this.$route.params.id, this.$route.params.quotation, this.record)
                    .then(() => {
                        this.clear()
                        this.errors = []
                        Notify.success(trans('the_record_has_been_saved'))
                    })
                    .catch(error => { this.errors = error.response.data.errors || [] })
                    .then(() => { this.isSaving = false })
            },
            loadProducts (supplierId) {
                this.loadingProducts = true

                getProducts(supplierId)
                    .then(response => { this.products = filter(response.data.products, (product) => product.product.active) })
                    .catch(() => Notify.success(trans('_notifications.error')))
                    .then(() => { this.loadingProducts = false })
            },
            clear () {
                this.record = {
                    show_details: false
                }
                this.product = null
                this.errors = []
            },
            cancel () {
                this.clear()
                this.$emit('close')
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/modules/deals/components/show/quotations/edit/products/Form.vue